U.googleTranslateSyncHiddenControls = function() {
	let hidden_voting_pane = document.getElementById('goog-gt-votingHiddenPane')
	if (hidden_voting_pane) {
		// Google injects this voting form for internal feedback flows. It is not part of
		// our UI, starts hidden, and should not appear in tab order or the accessibility tree.
		hidden_voting_pane.setAttribute('hidden', 'hidden')
		hidden_voting_pane.setAttribute('aria-hidden', 'true')
		hidden_voting_pane.setAttribute('inert', '')

		hidden_voting_pane.querySelectorAll('input, button, select, textarea, a').forEach(el => {
			el.setAttribute('tabindex', '-1')
			el.setAttribute('aria-hidden', 'true')
		})

		let hidden_control_labels = {
			'goog-gt-votingInputSrcLang': 'Hidden Google Translate source language input',
			'goog-gt-votingInputTrgLang': 'Hidden Google Translate target language input',
			'goog-gt-votingInputSrcText': 'Hidden Google Translate source text input',
			'goog-gt-votingInputTrgText': 'Hidden Google Translate translated text input',
			'goog-gt-votingInputVote': 'Hidden Google Translate vote input',
		}
		Object.entries(hidden_control_labels).forEach(([id, label]) => {
			let input = document.getElementById(id)
			if (!input) return
			input.setAttribute('aria-label', label)
			input.setAttribute('title', label)
		})
	}

	let voting_frame = document.querySelector('iframe[name="votingFrame"]')
	if (voting_frame) {
		voting_frame.setAttribute('hidden', 'hidden')
		voting_frame.setAttribute('aria-hidden', 'true')
		voting_frame.setAttribute('tabindex', '-1')
	}
}

U.googleTranslateElementInit = function() {
	// note that this code is used along with a caller in index.html

	// uncomment the below to cancel google translate functionality
	// $('#google_translate_element_wrapper').hide()
	// return

	// console.warn('GTI2')
	new google.translate.TranslateElement({
			pageLanguage: 'en', 
			includedLanguages: 'en,es,vi,fr,zh-CN,hi',
			// includedLanguages: 'ar,zh-CN,en,es',
			layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
			autoDisplay: false,
		}, 'google_translate_element'
	)
	U.googleTranslateSyncHiddenControls()

	window.google_translate_initialized = true

	// once every second...
	setInterval(x=>{
		// if google translate is showing the annoying spinner, hide it. This will likely need to be updated as google translate evolves
		let jq = $('#loom-companion-mv3').next()
		if (jq.find('svg').length > 0) {
			jq.hide()
		}

		U.googleTranslateSyncHiddenControls()
	}, 1000)
}
